<ng-container *ngIf="currentViewState">
    <ng-container ntapFilterViewProvider [viewName]="currentViewName" [viewState]="currentViewStateFilter" #filter>
        <ng-container appPretragaKatalogaProvider [viewName]="currentViewName" [viewState]="currentViewState" [tableColumns]="tablica" [listColumns]="lista" [gridColumns]="grid">
            <ntap-view-window target="globalDialog"></ntap-view-window>
            <ntap-dynamic [compId]="INIT_COMP_ID" [class]="currentViewClass"></ntap-dynamic>
           <app-premjesti-dialog></app-premjesti-dialog>
        </ng-container>
    </ng-container>
</ng-container>
<router-outlet></router-outlet>